<template>
  <div class="app-container">
    <PageTitle title="产品列表" ref="pageTitle" v-model="listQuery.city" @onChange="changeCity" />
    <div class="filter-container">
      <el-select
        clearable
        style="width: 160px"
        class="filter-item"
        v-model="listQuery.platform"
        placeholder="所属平台"
        @change="handlePlatform"
      >
        <el-option
          v-for="item in platform_options"
          :key="item.value"
          :label="item.name"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-input
        clearable
        style="width: 160px"
        class="filter-item"
        placeholder="请输入产品名称"
        v-model="listQuery.name"
        @change="handleName"
      ></el-input>
      <el-select
        clearable
        v-model="listQuery.project_name"
        filterable
        placeholder="请选择项目名称"
        style="width: 160px; margin-right: 10px"
        @change="changeProject"
      >
        <el-option
          v-for="item in project_options"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <el-select
        clearable
        style="width: 160px"
        class="filter-item"
        v-model="listQuery.trip_type"
        placeholder="请选择类型"
        @change="handleTripType"
      >
        <el-option label="拼团" :value="1"></el-option>
        <el-option label="包团" :value="2"></el-option>
      </el-select>
      <el-select
        clearable
        style="width: 160px"
        class="filter-item"
        v-model="listQuery.shelf_status"
        placeholder="请选择上下架状态"
        @change="handleShelfStatus"
      >
        <el-option label="下架" :value="0"></el-option>
        <el-option label="上架" :value="1"></el-option>
      </el-select>

      <el-button
        class="filter-item"
        type="primary"
        plain
        icon="el-icon-refresh-left"
        @click="handleReset"
        >重置</el-button
      >
      <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter"
        >搜索</el-button
      >
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-plus"
        @click="$refs.edit.handleCreate()"
        >添加产品</el-button
      >

      <el-button
        type="primary"
        size="mini"
        @click="handlebatchShelf([], 1)"
        style="margin-bottom: 10px"
        >批量上架</el-button
      >
      <el-button
        type="primary"
        size="mini"
        @click="handlebatchShelf([], 0)"
        style="margin-bottom: 10px"
        >批量下架</el-button
      >
    </div>

    <Table :data="list" :columns="columns" :loading="listLoading" @changeSelect="changeSelect">
      <template v-slot:selection>
        <el-table-column width="50" align="center" type="selection" :selectable="checkSelectable">
        </el-table-column>
      </template>
      <template v-slot:project>
        <el-table-column label="项目" width="140" align="center">
          <template slot-scope="scope">
            <p>{{ scope.row.project.name }}</p>
          </template>
        </el-table-column>
      </template>

      <template v-slot:trip_type>
        <el-table-column label="类型" width="110" align="center">
          <template slot-scope="scope">
            <el-link type="success" :underline="false">{{
              ['', '拼团', '包团'][scope.row.trip_type]
            }}</el-link>
          </template>
        </el-table-column>
      </template>

      <template v-slot:user_limit>
        <el-table-column label="人数上限" width="110" align="center">
          <template slot-scope="scope">
            <p v-if="scope.row.user_limit">{{ scope.row.user_limit }}人</p>
            <p v-else>不限</p>
          </template>
        </el-table-column>
      </template>
      <template v-slot:cost>
        <el-table-column label="结算价" width="110" align="center">
          <template slot-scope="scope">
            <p>¥{{ scope.row.cost }}</p>
          </template>
        </el-table-column>
      </template>
      <template v-slot:tc_ticket_id>
        <el-table-column label="同程门票" width="160">
          <template slot-scope="scope">
            <p>ID: {{ scope.row.tc_ticket_id }}</p>
            <p>名称: {{ scope.row.tc_ticket_name }}</p>
          </template>
        </el-table-column>
      </template>
      <template v-slot:platform>
        <el-table-column label="所属平台" width="140" align="center">
          <template slot-scope="scope">
            {{ $platform[scope.row.platform] }}
          </template>
        </el-table-column>
      </template>
      <template v-slot:shelf_status>
        <el-table-column label="上架状态" width="110" align="center">
          <template slot-scope="scope">
            {{ ['下架', '上架'][scope.row.shelf_status] }}
          </template>
        </el-table-column>
      </template>

      <template v-slot:action>
        <el-table-column label="操作" minWidth="260">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-edit"
              @click="$refs.edit.handleEdit(scope.row.id, 'edit')"
            />
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-delete"
              @click="handleDel(scope.row.id)"
            />
            <el-button
              type="primary"
              size="mini"
              @click="handlebatchShelf([scope.row.id], 1)"
              v-if="scope.row.shelf_status == 0"
              >上架</el-button
            >
            <el-button
              type="primary"
              size="mini"
              @click="handlebatchShelf([scope.row.id], 0)"
              v-if="scope.row.shelf_status == 1"
              >下架</el-button
            >
            <el-button
              type="primary"
              size="mini"
              @click="$refs.edit.handleCopy(scope.row.id, 'copy')"
              >复制</el-button
            >
          </template>
        </el-table-column>
      </template>
    </Table>
    <div class="pagination-container">
      <pagination
        :total="count"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.size"
        @pagination="fetchData"
      />
    </div>
    <Edit ref="edit" />
  </div>
</template>

<script>
import { getList as getProjectList } from '@/api/projects'
import { getList, del, batchShelf } from '@/api/products'
import PageTitle from '@/components/PageTitle'
import Edit from './components/Edit'
import { PLATFORM_OPTIONS } from '@/utils/platform'
export default {
  name: 'ProductsIndex',
  components: {
    PageTitle,
    Edit
  },
  data() {
    return {
      list: null,
      count: 0,
      listLoading: true,
      listQuery: {
        name: '',
        project_id: '',
        project_name: '',
        trip_type: '',
        page: 1,
        size: 10,
        city: '',
        platform: '',
        shelf_status: 1
      },
      project_options: [],
      platform_options: PLATFORM_OPTIONS,
      columns: [
        { type: 'selection', slot: 'selection' },
        {
          type: 'index',
          align: 'center',
          label: '序号',
          width: '50'
        },
        {
          label: '产品ID',
          width: '120',
          align: 'center',
          prop: 'id'
        },
        {
          label: '产品名称',
          width: '200',
          prop: 'name',
          showOverflowTooltip: true
        },
        {
          label: '项目',
          slot: 'project'
        },
        {
          label: '场次',
          width: '120',
          prop: 'interval_time',
          align: 'center'
        },
        {
          label: '类型',
          slot: 'trip_type'
        },
        {
          label: '人数上限',
          slot: 'user_limit'
        },
        {
          label: '结算价',
          slot: 'cost'
        },
        {
          label: '同程门票',
          slot: 'tc_ticket_id'
        },
        { label: '所属平台', slot: 'platform' },
        { label: '上架状态', slot: 'shelf_status' },

        {
          label: '操作',
          slot: 'action'
        }
      ],
      uuids: []
    }
  },
  created() {
    getProjectList({ size: 1000 }).then((res) => {
      this.project_options = res.data.results
    })
    this.fetchData()
  },
  mounted() {
    this.listQuery.city = this.$refs.pageTitle.city
  },
  methods: {
    // 获取数据
    fetchData() {
      this.listLoading = true
      getList(this.listQuery).then((res) => {
        this.list = res.data.results
        this.count = res.data.count
        this.listLoading = false
      })
    },
    /**
     * @description: 选择城市
     * @param {*} e
     * @return {*}
     */
    changeCity(e) {
      this.listQuery.city = e
      this.handleFilter()
    },
    /**
     * @description: 选择行
     * @return {*}
     */
    changeSelect(e) {
      this.uuids = e.map((item) => item.id)
    },
    /**
     * @description: 选择项目名称
     * @param {*} e
     * @return {*}
     */
    changeProject(value) {
      let list = this.project_options.filter((item) => item.id === value)

      this.listQuery.project_id = value
      this.listQuery.project_name = list[0].name
      this.user_limit = list[0].user_limit
      this.handleFilter()
    },
    // 筛选
    handleFilter() {
      this.listQuery.page = 1
      this.fetchData()
    },
    handlePlatform(value) {
      this.listQuery.platform = value
      this.handleFilter()
    },
    handleName(value) {
      this.listQuery.name = value
      this.handleFilter()
    },
    handleTripType(e) {
      this.listQuery.trip_type = e
      this.handleFilter()
    },
    handleShelfStatus(e) {
      this.listQuery.shelf_status = e
      this.handleFilter()
    },
    handleReset() {
      this.listQuery = {
        page: 1,
        size: 10,
        city: 1,
        name: '',
        project_id: '',
        project_name: '',
        trip_type: ''
      }
      this.fetchData()
    },
    handlebatchShelf(uuids, status) {
      this.$confirm(`确认${status === 1 ? '上架' : '下架'}选中的项目吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          batchShelf({
            product_ids: uuids.length === 0 ? this.uuids : uuids,
            shelf_status: status
          }).then(() => {
            this.$notify({
              title: '成功',
              message: '操作成功',
              type: 'success'
            })
            this.fetchData()
          })
        })
        .catch(() => {})
    },
    // 删除
    handleDel(uuid) {
      this.$confirm('确认删除该项目吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          del(uuid).then(() => {
            this.$notify({
              title: '成功',
              message: '删除成功',
              type: 'success'
            })
            this.fetchData()
          })
        })
        .catch(() => {})
    }
  }
}
</script>
<style scoped>
.filter-container {
  justify-content: flex-start !important;
  flex-wrap: wrap;
}
</style>
